import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=74370ca8&scoped=true"
import script from "./activity.vue?vue&type=script&lang=js"
export * from "./activity.vue?vue&type=script&lang=js"
import style0 from "./activity.vue?vue&type=style&index=0&id=74370ca8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74370ca8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74370ca8')) {
      api.createRecord('74370ca8', component.options)
    } else {
      api.reload('74370ca8', component.options)
    }
    module.hot.accept("./activity.vue?vue&type=template&id=74370ca8&scoped=true", function () {
      api.rerender('74370ca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/design/activityDesign/activity.vue"
export default component.exports